import { compose, withHandlers, withProps, withState } from 'recompose';

export default compose(
  withProps((props) => {
    const predefinedAmounts = [5000, 10000, 20000];
    return {
      predefinedAmounts,
      hasCustomGcAmount: props.gcAmount && !predefinedAmounts.some(amount => amount === props.gcAmount),
    };
  }),
  withState('customGcOpen', 'setCustomGcOpen', false),
  withState('customGcAmount', 'setCustomGcAmount', 0),
  withHandlers({
    toggleCustomGc: props => () => {
      if (!props.customGcOpen) {
        props.setCustomGcAmount(0);
      }
      props.setCustomGcOpen(!props.customGcOpen);
    },
    onCustomGcChange: props => (amount) => {
      props.setCustomGcAmount(Number(amount));
    },
    onCustomGcSubmit: props => (e) => {
      e.preventDefault();
      props.onGcAmountChange(props.customGcAmount);
      props.setCustomGcOpen(false);
    },
    onGcAmountChange: props => (amount) => {
      if (props.customGcOpen) {
        props.setCustomGcOpen(false);
      }

      props.onGcAmountChange(amount);
    },
  }),
);



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/GiftCardAmount/GiftCardAmountContainer.js